import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=66d71d45&scoped=true"
import script from "./LeftBar.vue?vue&type=script&lang=js"
export * from "./LeftBar.vue?vue&type=script&lang=js"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=66d71d45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d71d45",
  null
  
)

export default component.exports